import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appCoordinates]'
})
export class CoOrdinatesDirective {

  regexStr = '^[0-9\.\N\E\W\S\-]*$';
  @Input() isAlphaNumeric: boolean;

  constructor(private el: ElementRef) { }

  @HostListener('keypress', ['$event']) onKeyPress(event) {
    this.validateFields(event);
    return new RegExp(this.regexStr).test(event.key);
  }

  @HostListener('paste', ['$event']) blockPaste(event: KeyboardEvent) {
    this.validateFields(event);
  }

  validateFields(event) {
    setTimeout(() => {
    // if(Number(event.target.value)>100){
    //   this.el.nativeElement.value = this.el.nativeElement.value.replace(/[]/g, '')
    // }else{
this.el.nativeElement.value = this.el.nativeElement.value.replace(/[^0-9\.\N\E\W\S\-]/g, '');
      event.preventDefault();
    }, 100)
  }


}
